enum Activity {
  Files = "files",
  Concepts = "concepts",
  Publish = "publish",
}

export default Activity;
